import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse, PaginatedPayload } from "../../types/ApiResponse";
import { getNotificationsApi } from "../../helpers/ApiManager";

import {
  NotificationParams,
  NotificationPayloadData,
} from "types/notification.api";

export const getNotifications = createAsyncThunk<
  ApiResponse<PaginatedPayload<NotificationPayloadData>>, // return type
  NotificationParams | undefined, // argument type
  { rejectValue: string } // rejected type
>("notifications", async (params, { rejectWithValue }) => {
  try {
    const response = await getNotificationsApi(params);
    console.log(response);

    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});
